/**
 * 写作模式状态管理
 * 用于 Cloudflare 私有版在静态题库和 AI 写作之间切换
 */

export type WritingModeType = 'static' | 'ai';

const STORAGE_KEY = 'enpass_writing_mode';

/** 获取当前写作模式 */
export function getWritingMode(): WritingModeType {
  const stored = localStorage.getItem(STORAGE_KEY);
  if (stored === 'static' || stored === 'ai') {
    return stored;
  }
  return 'static'; // 默认使用静态题库
}

/** 设置写作模式 */
export function setWritingMode(mode: WritingModeType): void {
  localStorage.setItem(STORAGE_KEY, mode);
}

/** 检查是否是 AI 写作模式 */
export function isAIWritingMode(): boolean {
  return getWritingMode() === 'ai';
}
